import { render, staticRenderFns } from "./EditColor.vue?vue&type=template&id=7f941316&scoped=true&"
import script from "./EditColor.vue?vue&type=script&lang=js&"
export * from "./EditColor.vue?vue&type=script&lang=js&"
import style0 from "./EditColor.vue?vue&type=style&index=0&id=7f941316&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f941316",
  null
  
)

export default component.exports